<div class="flex h-screen overflow-hidden bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-100"
  (click)="onLayoutClick()">

  <!-- Sidebar desktop -->
  <app-menu class="hidden md:block flex-shrink-0"></app-menu>

  <!-- Mobile sidebar overlay -->
  @if (mobileMenuOpen) {
    <div
      class="fixed inset-0 z-40 bg-black/50 md:hidden"
      (click)="mobileMenuOpen = false">
    </div>
  }
  <!-- Mobile sidebar panel -->
  @if (mobileMenuOpen) {
    <div
      class="fixed inset-y-0 left-0 z-50 w-64 md:hidden shadow-2xl"
      (click)="$event.stopPropagation()">
      <app-menu></app-menu>
    </div>
  }

  <!-- Main content: topbar + page -->
  <div class="flex flex-col flex-1 min-w-0 overflow-y-auto">
    <app-topbar></app-topbar>
    <app-welcome></app-welcome>
    <div class="flex-1 p-6">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
</div>

<p-confirmDialog key="confirm1" [style]="{width: '425px'}"
  acceptButtonStyleClass="p-button-text"
rejectButtonStyleClass="p-button-text"></p-confirmDialog>
<p-confirmDialog key="confirm2" [style]="{width: '425px'}"
  acceptButtonStyleClass="p-button-text"
rejectButtonStyleClass="p-button-text"></p-confirmDialog>

<app-assistant></app-assistant>
